import css from "./Footer.module.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation("home");

  return (
    <footer className={css.footer} role="contentinfo">
      <div className={css.container}>
        <div className={css.brandCol}>
          <div className={css.logo}>
            <a target="blank" href="https://processbasedpersonality.com/">
              Process Based Personality
            </a>
          </div>
          <p className={css.tag}>{t("footer_phrase")}</p>
        </div>

        {/* <nav className={css.navCol} aria-label="Explorar">
          <div className={css.colTitle}>Explorar</div>
          <ul>
            <li>
              <Link to="/library">Biblioteca</Link>
            </li>
            <li>
              <Link to="/programs">Programas</Link>
            </li>
            <li>
              <Link to="/video/sample">Vídeos</Link>
            </li>
          </ul>
        </nav> */}

        {/* <div className={css.navCol} aria-label="Institucional">
          <div className={css.colTitle}>Institucional</div>
          <ul>
            <li>
              <Link to="/about">Sobre</Link>
            </li>
            <li>
              <Link to="/for-pros">Para profissionais</Link>
            </li>
            <li>
              <Link to="/contact">Contato</Link>
            </li>
          </ul>
        </div> */}

        <div className={css.navCol} aria-label="Legal">
          <div className={css.colTitle}>Legal</div>
          <ul>
            <li>
              <Link to="/terms">{t("footer_terms")}</Link>
            </li>
            <li>
              <Link to="/privacy">{t("footer_privacy")}</Link>
            </li>
            <li>
              <Link to="/cookies">Cookies</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className={css.bottom}>
        <div>
          © {new Date().getFullYear()} Process Based Personality —{" "}
          {t("footer_developed")}{" "}
          <a target="blank" href="https://thiagorocha.ibhava.com/">
            Thiago Rocha
          </a>
        </div>
      </div>
    </footer>
  );
}
